import React, { FC } from 'react'

import cn from 'clsx'

import styles from './AppCard.module.scss'
import { AppCardProps } from './AppCard.types'

export const AppCard: FC<AppCardProps> = ({ app, ...props }) => (
  <div {...props} className={cn(styles.appCard, props.className)}>
    <div className={styles.icon}>
      <img src={app.icon} width={50} height={50} />
    </div>
    <strong className={styles.name}>{app.name}</strong>
    <p className={styles.description}>{app.description}</p>
    <div className={styles.tags}>
      {app.tags.map(tag => (
        <div key={tag} className={styles.tag}>
          {tag}
        </div>
      ))}
    </div>
    <img
      src={app.illustrationUrl}
      alt={`${app.name} illustration`}
      className={styles.illustration}
    />
  </div>
)
